import axios from 'axios';
const BASE_URL = 'https://api.mebel3d.by/';
// const BASE_URL = 'http://87.249.49.149/';
// const BASE_URL = 'https://littlebrushedbook36.conveyor.cloud/';

export const baseUrl = 'https://api.mebel3d.by';

export default axios.create({
    baseURL: BASE_URL
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    },
});